import Vue from 'vue';
import Buefy from 'buefy';
import moment from 'moment';
import {decode} from 'html-entities';
import {ModalProgrammatic as Modal} from 'buefy';
import VueNumber from 'vue-number-animation';
import VueUploadComponent from 'vue-upload-component'

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ScrollTo from 'vue-scrollto';

window.Vue = require('vue');
window.htmlEntity = require('html-entities');
window.moment = require('moment');
window.axios = require('axios');
window.Modal = Modal;

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import HighchartsSankey from 'highcharts/modules/sankey';
import HighchartsDrillDown from 'highcharts/modules/drilldown';
import HighchartsWordCloud from 'highcharts/modules/wordcloud';
import HighchartsNetworkGraph from 'highcharts/modules/networkgraph';
import HighchartsMore from 'highcharts/highcharts-more';
import treemap from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';

import VueSlider from 'vue-slider-component';
import VueRecaptcha from 'vue-recaptcha';

Vue.prototype.$services = {
	'aiDocuments': require("./services/AiDocumentsService").default,
	'alertPreferences': require("./services/AlertPreferencesService").default,
	'alertSettings': require("./services/AlertSettingsService").default,
	'AzureSearches': require("./services/AzureSearchService").default,
	'chatStatistics': require("./services/ChatStatisticsService").default,
	'chatEping': require("./services/ChatEpingService").default,
	'chats': require("./services/ChatsService").default,
	'contacts': require("./services/ContactsService").default,
	'contactAuditTrails': require("./services/ContactAuditTrailsService").default,
	'contactGroups': require("./services/ContactGroupsService").default,
	'contactGroupMembers': require("./services/ContactGroupMembersService").default,
	'countries': require("./services/CountriesService").default,
	'countryGroups': require("./services/CountryGroupsService").default,
	'countryNotificationLanguages': require("./services/CountryNotificationLanguagesService").default,
	'crnNotifications': require("./services/CRNNotificationsService").default,
	'dialects': require("./services/DialectsService").default,
	'factsAndFigures': require("./services/FactsAndFiguresService").default,
	'forums': require("./services/ForumsService").default,
	'forumSettings': require("./services/ForumSettingsService").default,
	'forumThreads': require("./services/ForumThreadsService").default,
	'forumStatistics': require("./services/ForumStatisticsService").default,
	'externalContacts': require("./services/ExternalContactsService").default,
	'hsVersions': require("./services/HSVersionsService").default,
	'hsProducts': require("./services/HSProductsService").default,
	'icsProducts': require("./services/ICSProductsService").default,
	'keywords': require("./services/KeywordsService").default,
	'memberProfiles': require("./services/MemberProfilesService").default,
	'nationalForumSettings': require("./services/NationalForumSettingsService").default,
	'nepUsers': require("./services/NEPUsersService").default,
	'news': require("./services/NewsService").default,
	'newsAndEvents': require("./services/NewsAndEventsService").default,
	'notifications': require("./services/NotificationsService").default,
	'notificationAttachments': require("./services/NotificationAttachmentsService").default,
	'notificationFormats': require("./services/NotificationFormatsService").default,
	'notificationStatuses': require("./services/NotificationStatusesService").default,
	'objectives': require("./services/ObjectivesService").default,
	'objectiveDomains': require("./services/ObjectiveDomainsService").default,
	'orgTypes': require("./services/OrgTypesService").default,
	'questionAndFeedBacks': require("./services/QuestionAndFeedBacksService").default,
	'registration': require("./services/RegistrationService").default,
	'resources': require("./services/ResourcesService").default,
	'spsRegularNotifications': require("./services/SPSRegularNotificationsService").default,
	'spsEmergencyNotifications': require("./services/SPSEmergencyNotificationsService").default,
	'spsAddendumNotifications': require("./services/SPSAddendumNotificationsService").default,
	'spsCorrigendumNotifications': require("./services/SPSCorrigendumNotificationsService").default,
	'spsSupplementNotifications': require("./services/SPSSupplementNotificationsService").default,
	'spsRecognitionOfEquivalenceNotifications': require("./services/SPSRecognitionOfEquivalenceNotificationsService").default,
	'staticContents': require("./services/StaticContentsService").default,
	'staticVideos': require("./services/StaticVideosService").default,
	'symbols': require("./services/SymbolsService").default,
	'tbtRegularNotifications': require("./services/TBTRegularNotificationsService").default,
	'tbtRevisionNotifications': require("./services/TBTRevisionNotificationsService").default,
	'tbtAddendumNotifications': require("./services/TBTAddendumNotificationsService").default,
	'tbtCorrigendumNotifications': require("./services/TBTCorrigendumNotificationsService").default,
	'tbtSupplementNotifications': require("./services/TBTSupplementNotificationsService").default,
	'tbtArticle152Notifications': require("./services/TBTArticle152NotificationsService").default,
	'tbtArticle152V2AddendumNotifications': require("./services/TBTArticle152V2AddendumNotificationsService").default,
	'tbtArticle152V2CorrigendumNotifications': require("./services/TBTArticle152V2CorrigendumNotificationsService").default,
	'tbtArticle152V2RevisionNotifications': require("./services/TBTArticle152V2RevisionNotificationsService").default,
	'tbtArticle107Notifications': require("./services/TBTArticle107NotificationsService").default,
	'tbtCodeOfGoodPracticeNotifications': require("./services/TBTCodeOfGoodPracticeNotificationsService").default,
	'tprs': require("./services/TPRsService").default,
	'unofficialTranslations': require("./services/UnofficialTranslationsService").default,
	'users': require("./services/UsersService").default,
	'userComments': require("./services/UserCommentsService").default,
	'userDomainHistories': require("./services/UserDomainHistoriesService").default,
	'userDomains': require("./services/UserDomainsService").default,
	'userFilters': require("./services/UserFiltersService").default,
	'userNotifications': require("./services/UserNotificationsService").default,
	'tradeConcerns': require("./services/TradeConcernsService").default,
	'tools': require("./services/ToolsService").default,
	'otherDocuments': require("./services/OtherDocumentsService").default,
	'organizations': require("./services/OrganizationsService").default,
	'otherDocumentKeywords': require("./services/OtherDocumentKeywordsService").default,
	'otherDocumentTypes': require("./services/OtherDocumentTypesService").default,
};

HighchartsSankey(Highcharts);
HighchartsDrillDown(Highcharts);
HighchartsWordCloud(Highcharts);
HighchartsNetworkGraph(Highcharts);
HighchartsMore(Highcharts);

treemap(Highcharts);
exporting(Highcharts);
exportData(Highcharts);

Vue.use(HighchartsVue);
Vue.use(CKEditor);
Vue.use(ScrollTo, {
	container: 'body',
	duration: 500,
	easing: 'ease',
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true,
});

Vue.component('file-upload', VueUploadComponent);
Vue.component('vue-slider', VueSlider);
Vue.component('vue-recaptcha', VueRecaptcha);

Highcharts.theme = {
	colors: ['#24c280', '#24c28080',  '#0092cd','#0092cd80',  '#d9643c','#d9643c80',  '#e1dd5f', '#e1dd5f80'],
	//colors: ['#24c280', '#0092cd', '#d9643c', '#e1dd5f'],
};
Highcharts.setOptions(Highcharts.theme);

Vue.use(VueNumber);
Vue.use(Buefy,
	{
		defaultIconPack: 'fal',
		defaultContainerElement: '#app',
		defaultLocale: 'en_GB'
		// ... https://buefy.org/documentation/constructor-options
	});

Vue.filter('dateFilter', function (value) {
	if (value) {
		// let newDate = moment(new Date(date.get('year'), date.get('month'), date.get('date'), date.get('hour'), date.get('minute'))).add(new Date().getTimezoneOffset()*-1, 'm').toDate();
		return moment.utc(String(value)).format('DD/MM/YYYY');		
	}
});

Vue.filter('dateTimeFilter', function (value) {
	if (value) {
		return moment.utc(String(value)).format('DD/MM/YYYY hh:mm:ss a');
	}
});

Vue.filter('chatDateTimeFilter', function (value) {
	if (value) {
		return moment.utc(String(value)).format('DD MMM YYYY HH:mm');
	}
});

Vue.filter('dateMonthNameFilter', function (value) {
	if (value) {
		//return moment.utc(String(value)).format('DD MMMM YYYY');
		return ((moment.utc(String(value))).locale(window.currentLanguage)).format('DD MMMM YYYY');
	}
});

Vue.filter('stripHtml', function (value) {
	var div = document.createElement("div");
	div.innerHTML = value;
	var text = div.textContent || div.innerText || "";
	return text;
});

Vue.filter('decodeHTMLEntity', function (value) {
	if (value) {
		return decode(value);
	}
});

let handleOutsideClick;
Vue.directive('closable', {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const {handler, exclude} = binding.value;
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach(refName => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					// Get the element using the reference name
					const excludedEl = vnode.context.$refs[refName];
					// See if this excluded element
					// is the same element the user just clicked on
					if (excludedEl) clickedOnExcludedEl = excludedEl.contains(e.target);
				}
			})
			// We check to see if the clicked element is not
			// the dialog element and not excluded
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				vnode.context[handler]();
			}
		}
		// Register click/touchstart event listeners on the whole page
		document.addEventListener('click', handleOutsideClick);
		document.addEventListener('touchstart', handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener('click', handleOutsideClick);
		document.removeEventListener('touchstart', handleOutsideClick);
	}
});

require('./components/component-loader');

